import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../layouts/Layout';
import { Komprehensif } from '../../componen/invoiceall/Komprehensif';

export const KomprehensifPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
    <Layout>
    <Komprehensif />
  </Layout>
  )
}
